import * as Types from 'src/actions/image/get/Types';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'src/reducers/RootReducer';
import { ActionCreator, Dispatch } from 'react-redux';
import ApiClient from 'src/services/api-client/ApiClient';
import { AxiosResponse } from 'axios';
import ValidatorService from 'src/services/validation/Validation.service';

export interface GetImageAttempt extends Action {
  type: Types.GET_IMAGE_ATTEMPT;
}

export interface GetImageSuccess extends Action {
  type: Types.GET_IMAGE_SUCCESS;
  payload: File;
}

export interface GetImageFailure extends Action {
  type: Types.GET_IMAGE_FAILURE;
  payload: {};
}

export type GetImageAction = GetImageAttempt | GetImageSuccess | GetImageFailure | File;

export interface GetImageThunk extends ThunkAction<Promise<GetImageAction>, RootState, null> {
}

export const getImageAttempt: ActionCreator<GetImageAttempt> = () => (
  { type: Types.GET_IMAGE_ATTEMPT }
);

export const getImageSuccess: ActionCreator<GetImageSuccess> = (image: File) => (
  {
    type: Types.GET_IMAGE_SUCCESS,
    payload: image
  }
);

export const getImageFailure: ActionCreator<GetImageFailure> = (error: {}) => (
  {
    type: Types.GET_IMAGE_FAILURE,
    payload: error
  }
);

export const getImage: ActionCreator<GetImageThunk> = (
  imageName: string
): GetImageThunk => {

  return (dispatch: Dispatch<RootState>): Promise<GetImageAction> => {
    dispatch(getImageAttempt());

    if (imageName.indexOf('http') === -1) {
      return ApiClient.file.get(imageName)
        .then((response: AxiosResponse<File>) => {

          const image: File = response.data;

          return dispatch(getImageSuccess(image));
        }).catch((e: { response: { data: { error: {} } } }): GetImageFailure => {
          const errorMessages = ValidatorService
            .translateValidations(e && e.response && e.response.data && e.response.data.error);

          return dispatch(getImageFailure(errorMessages));
        });
    } else {
      return new Promise((resolve, reject) => {
        const xhr: XMLHttpRequest = new XMLHttpRequest();

        xhr.open('GET', imageName, true);
        xhr.responseType = 'blob';
  
        xhr.onload = function() {
          resolve(dispatch(getImageSuccess(this.response)));
        };
  
        xhr.onerror = function() {
          reject(dispatch(getImageFailure(`Couldn't fetch ${imageName}`)));
        };
        
        xhr.send();
      });
    }
  };
};



// WEBPACK FOOTER //
// ./src/actions/image/get/GetImage.actions.tsx